import { BsModalService } from 'ngx-bootstrap/modal';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { CivilDisclaimerComponent } from './civil-disclaimer/civil-disclaimer.component';
import { EventService } from '../shared/event.service';

@Injectable()
export class CanActivateDisclaimerGuard implements CanActivate {

  constructor(private eventService: EventService,
             private modalService: BsModalService,
              private router: Router) {}

  canActivate() {

    const modalRef = this.modalService.show(CivilDisclaimerComponent, {backdrop: 'static', keyboard: false});
    return new Promise<boolean>((resolve, reject) => {
        modalRef.content.userChoice$.subscribe(value => {
            resolve(value);
            modalRef.hide();
            if (!value) {
                this.router.navigateByUrl('/');
            }
        });
        this.eventService.clearHistoryRequested$.subscribe(() => {
            resolve(false);
            modalRef.hide();
        });
     });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/can-activate-disclaimer-guard.ts